import React, { useState } from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';
import { FidemChat } from './FidemChat';

const SUGGEST = ['¿Qué causas de la cartera están en mayor riesgo y qué hago hoy?', '¿Qué lecciones dejan mis causas perdidas?', 'Redacta los descargos de mi causa activa', '¿Qué normas nuevas afectan a mis clientes?'];

// Fidem in the admin panel: thin collapsible bar under the header; opening it pushes content down instead of covering it
export const AdminFidemBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="admin-fidem-bar" className="border-b border-amber-500/30 bg-slate-950/95">
      <button data-testid="admin-fidem-toggle" onClick={() => setOpen(!open)} className="mx-auto flex w-full max-w-7xl items-center gap-2 px-6 py-2 text-left text-sm">
        <Sparkles className="h-4 w-4 shrink-0 text-amber-400" />
        <span className="font-semibold text-amber-200">Fidem</span>
        <span className="hidden truncate text-xs text-slate-400 sm:inline">abogado experto en todas las áreas · aprende de Cerebro, el CRM, tus causas cerradas, tus evaluaciones y BCN</span>
        <span className="ml-auto text-xs text-slate-400">{open ? 'Cerrar' : 'Preguntar'}</span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <div data-testid="admin-fidem-panel" className="mx-auto max-w-7xl px-6 pb-4"><FidemChat height="h-[45vh]" suggest={SUGGEST} /></div>}
    </div>
  );
};
